enum YesNoChoices {
  YES = "Yes",
  NO = "No",
}

export default YesNoChoices;
